// extracted by mini-css-extract-plugin
export default {"KeyGiversView":"KeyGiversView_KeyGiversView__1QtxJ"};